/**
 * TWO DIFFERENT EMPTIES. A window with no rows is often the most useful thing
 * on the page ("nothing broke this week" is a result, not a fault) and gets
 * per-card wording; a panel the payload never had is a developer problem and
 * says so.
 */
export const EmptyState = ({ text }: { text: string }) => (
  <p className="text-muted text-sm">{text}</p>
)

export const Missing = ({ name }: { name: string }) => (
  <p className="text-muted text-sm">
    “{name}” is not in the payload. Check getInsightsPayload and the nightly
    refresh in zealth-analytics.
  </p>
)
